module.exports = __webpack_public_path__ + "static/media/icon-enemy.cf600223.svg";